import React, { useEffect, useRef, useState } from "react";
import "./EducentreCoaching.less";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  useGetUpcomingClassesQuery,
  useGetCourseRecommendationQuery,
} from "../../../redux/services/class";
import { Row, Typography, Button, Spin } from "antd";
import { Link } from "react-router-dom";
import { LectureCard } from "../../../component";
import { EmptyCard, OtherCoursesCard } from "../../../component";
import { ROUTE_VIEW_ALL_CLASSROOM_UPCOMING } from "../../../constant/routes";
import ScheduleTable from "./ScheduleTable/ScheduleTable";
import { useGetBatchFeeStructureQuery } from "../../../redux/services/batches";

const EducentreCoaching = () => {
  const { currentCoachingName, setCurrentCoachingLogo } = useSelector(
    (state) => state.auth
  );
  const { coaching_id } = useParams();
  const { student_id } = useSelector((state) => state.auth);
  const { data: batchFeeStructure, isLoading: batchFeeStructureLoading } =
    useGetBatchFeeStructureQuery(coaching_id);
  const scrollRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const userScrollTimeout = useRef(null);
  const { Title } = Typography;
  const { data: upcomingClasses, isLoading: classLoading } =
    useGetUpcomingClassesQuery({
      student_id: student_id,
      coaching_id: coaching_id,
    });
  const { data: courseRecommendation, isLoading: courseRecommendationLoading } =
    useGetCourseRecommendationQuery({
      student_id: student_id,
    });

  useEffect(() => {
    if (!scrollRef.current || !courseRecommendation?.data?.length) return;

    const scrollContainer = scrollRef.current;

    const scrollToNextCard = () => {
      if (isUserScrolling) return;

      const totalCards = courseRecommendation.data.length;
      if (!scrollContainer.firstChild) return;

      const cardWidth = scrollContainer.firstChild.clientWidth + 30; // Include margin
      const nextIndex = (currentIndex + 1) % totalCards;

      scrollContainer.scrollTo({
        left: nextIndex * cardWidth,
        behavior: "smooth",
      });

      setCurrentIndex(nextIndex);
    };

    const intervalId = setInterval(scrollToNextCard, 3000);

    return () => clearInterval(intervalId);
  }, [currentIndex, courseRecommendation, isUserScrolling]);

  // Detect user scrolling
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const handleUserScroll = () => {
      setIsUserScrolling(true);

      if (userScrollTimeout.current) clearTimeout(userScrollTimeout.current);

      userScrollTimeout.current = setTimeout(() => {
        setIsUserScrolling(false);
      }, 3000);
    };

    scrollContainer.addEventListener("scroll", handleUserScroll);
    scrollContainer.addEventListener("mousedown", handleUserScroll);
    scrollContainer.addEventListener("touchstart", handleUserScroll);

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleUserScroll);
        scrollContainer.removeEventListener("mousedown", handleUserScroll);
        scrollContainer.removeEventListener("touchstart", handleUserScroll);
      }
    };
  }, []);

  return (
    <div className='educentre-coaching-container'>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <img src={setCurrentCoachingLogo} />
        <span>
          {currentCoachingName ? currentCoachingName : "Coaching Name"}
        </span>
      </div>

      <ScheduleTable />

      <div className='upcoming-classes'>
        <Row justify='space-between'>
          <Title className='title'>Upcoming Assignments</Title>
          <Link
            to={ROUTE_VIEW_ALL_CLASSROOM_UPCOMING.replace(
              ":coaching_id",
              coaching_id
            )}
          >
            <Button
              type='link'
              className='view-all-button'
              disabled={!upcomingClasses?.data?.length}
            >
              View all
            </Button>
          </Link>
        </Row>

        <Spin spinning={classLoading}>
          <div className='card-scroll-container'>
            {upcomingClasses?.data?.length > 0 ? (
              upcomingClasses?.data?.map((lecture) => (
                <LectureCard
                  key={lecture.lecture_id}
                  lectureName={lecture.lecture_name}
                  dateTime={`${lecture.date} at ${lecture.time}`}
                  lectureImage={lecture.lecture_image}
                  classUrl={lecture.class_url}
                />
              ))
            ) : (
              <EmptyCard text='No Upcoming Classes' />
            )}
          </div>
        </Spin>
      </div>

      <div className='recommendation-courses'>
        <Title className='title'>Other Courses</Title>
        <Spin spinning={courseRecommendationLoading}>
          <div className='card-scroll-container' ref={scrollRef}>
            {courseRecommendation?.data?.length > 0 ? (
              courseRecommendation.data.map((othercourses) => (
                <OtherCoursesCard
                  key={othercourses.course_id}
                  subjectname={othercourses.course_subject}
                  status={othercourses.batch_type}
                  lectureImage={othercourses.course_banner}
                />
              ))
            ) : (
              <EmptyCard text='No Recommendations yet' />
            )}
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default EducentreCoaching;
